import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

import AuthContext from '../../contexts/AuthContext';
import { buttonBackground } from '../../styles/colors';

import {
  Container,
  InnerContainer,
  Title,
} from './elements';

const OwnerPortalUser = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid ${buttonBackground};
  cursor: pointer;
`;

const FBOName = styled.div`
  font-size: 1.5rem;
`;

const Choose = ({ token }) => {
  const { updateOwnerPortalUserId, user } = useContext(AuthContext);

  const ownerPortalUsers = (user?.ownerPortalUsers || [])
    .filter(ownerPortalUser => 'Fbo' === ownerPortalUser.ownerType);

  return (
    <>
      <Helmet>
        <title>Choose FBO Access</title>
      </Helmet>
      <Container>
        <InnerContainer>
          <Title>Choose FBO Access</Title>
          {ownerPortalUsers.map(ownerPortalUser => (
            <OwnerPortalUser
              key={ownerPortalUser.id}
              onClick={() => updateOwnerPortalUserId(ownerPortalUser.id)}
            >
              <FBOName>
                {`${ownerPortalUser.ownerName} - ${ownerPortalUser.ownerAirportCode}`}
              </FBOName>
              User Type: {ownerPortalUser.role}
            </OwnerPortalUser>
          ))}
        </InnerContainer>
      </Container>
    </>
  )
}

export default Choose;
